import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import axios from 'axios';
import Signin from './pages/Signin';
import SignUp from './pages/SignUp';
import Navbar from './components/Navbar';
import Project from './pages/Project';
import TopLogo from './components/TopLogo';
import Invoice from './pages/Invoice'
import IndInv from './pages/IndInv';
import Activate from './pages/Activate';
import ResetPas from './pages/ResetPas';
import Details from './pages/Details';
import RPC from './pages/RPC';
import Home from './Landing/components/pages/Home'
import NavTopRight from './components/NavTopRight';
import ProjectDetails from './pages/ProjectDetails';
import Loader from './components/Loader';
import Contracts from './pages/Contracts';
import Aggrements from './pages/Aggrements';
import DropDown from './components/DropDown';
import Users from './pages/Users';
import SingleUser from './components/SingleUser';
import Dashboard from './pages/Dashboard';
function App() {
  const project = 'projects'
  const contract = 'contracts'
  useEffect(()=>{
    document.getElementsByClassName('loadmain')[0].style.display='none'
  },[])
  return (
    <>
    <div className='noti'></div>
      <Router>
        <Loader />
        <Routes>
          {/* <Route index element={<><Home /></>}/> */}
          <Route path='/' element={<><Home /></>} />
          <Route path='/SignIn' element={<><TopLogo /><Signin /></>} />
          <Route path='/SignUp' element={<><TopLogo /><SignUp /></>} />
          <Route path='/ResetPass' element={<><TopLogo /><ResetPas /></>} />
          <Route path='/password/reset/confirm/:uid/:token' element={<><TopLogo /><RPC /></>} />
          <Route path='/activate/:uid/:token' element={<><TopLogo /><Activate /></>} />
          <Route path='*' element={
            <div id='body' >
              <NavTopRight />
              <Navbar />
              <div className='divbap'>
                <Routes>
                  <Route path='/dashboard' element={<Dashboard />} />
                  {/* <Route path='/projectDetails/' element={<div id='body' ><NavTopRight/><ProjectDetails />} /> */}
                  <Route path='/details' element={<Details />} />
                  <Route path='/Projects' element={<Project />} />
                  <Route path='/ProjectDetails/:slug' element={<ProjectDetails path={'projects'} />} />
                  <Route path='/ContractDetails/:slug' element={<ProjectDetails path={'contracts'} />} />
                  <Route path='/Invoice' element={<Invoice />} />
                  {/* <Route path='/DropDown' element={<><NavTopRight /><br /><br /><br /><br /><br /><br /><DropDown /></>} /> */}
                  <Route path='/contracts' element={<Contracts />} />
                  <Route path='/Invoice/:inv' element={<IndInv />} />
                  <Route path='/agreements' element={<Aggrements />} />
                  <Route path='/users' element={<Users />} />
                  <Route path='/users/:user' element={<SingleUser />} />
                </Routes>
              </div>
            </div>
          } />
        </Routes>

      </Router>
    </>
  );
}

export default App;
